import { render, staticRenderFns } from "./index-completata.vue?vue&type=template&id=7abd0976&"
import script from "./index-completata.vue?vue&type=script&lang=js&"
export * from "./index-completata.vue?vue&type=script&lang=js&"
import style0 from "./index-completata.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports